import React, { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// The tabs' own screens: going from one to another only cross-fades.
const TABS = ["/", "/bookings", "/messages", "/account", "/partner/dashboard"];

/**
 * The apps' move from one screen to the next (never mounted on the website):
 * forward slides 24 px in from the right, back (POP) from the left, in
 * 300 ms; a tab to another tab only fades (index.css, tk-page-enter).
 */
export default function AppTransition({ children }) {
  const { pathname } = useLocation();
  const type = useNavigationType();
  const ref = useRef(null);
  const previous = useRef(pathname);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || previous.current === pathname) return undefined;
    const tabSwitch = TABS.includes(pathname) && TABS.includes(previous.current);
    previous.current = pathname;
    el.classList.remove("tk-page-enter-active");
    el.classList.add("tk-page-enter");
    el.dataset.dir = type === "POP" ? "back" : "forward";
    el.dataset.tab = String(tabSwitch);
    let second = 0;
    const first = requestAnimationFrame(() => {
      second = requestAnimationFrame(() => {
        el.classList.add("tk-page-enter-active");
        el.classList.remove("tk-page-enter");
      });
    });
    return () => { cancelAnimationFrame(first); cancelAnimationFrame(second); };
  }, [pathname, type]);

  return <div ref={ref} data-testid="app-transition">{children}</div>;
}
